import { render, staticRenderFns } from "./iper.vue?vue&type=template&id=d2bc0c64"
import script from "./iper.vue?vue&type=script&lang=js"
export * from "./iper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports